import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getDatabase, ref, get, update } from 'firebase/database';
import './MessageDetail.css';

const MessageDetail = () => {
    const { messageId } = useParams();
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const db = getDatabase();

    useEffect(() => {
        const messageRef = ref(db, `messages/${messageId}`);
        get(messageRef).then((snapshot) => {
            if (snapshot.exists()) {
                const msg = snapshot.val();
                setMessage(msg);
                setLoading(false);
                if (!msg.isRead) {
                    update(messageRef, { isRead: true });
                }
            } else {
                setLoading(false);
            }
        });
    }, [messageId, db]);

    if (loading) {
        return <p>Loading message...</p>;
    }

    if (!message) {
        return <p>Message not found.</p>;
    }

    return (
        <div className="message-detail-container">
            <div className="message-header">
                <h2>{message.subject}</h2>
                <p><strong>From:</strong> {message.fromName || message.from}</p>
                <p><strong>To:</strong> {message.toName || message.to}</p>
                <p><strong>Date:</strong> {new Date(message.timestamp).toLocaleString()}</p>
            </div>
            <div className="message-body">
                <p>{message.body}</p>
            </div>
        </div>
    );
};

export default MessageDetail;
